import { FC, PropsWithChildren } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "./components/sidebar/Sidebar";
import { LoginPage } from "./pages/auth/LoginPage";
import { RegisterPage } from "./pages/auth/RegisterPage";
import { LogsPage } from "./pages/logs/LogsPage";
import { OrderSearch } from "./pages/orders/OrderSearch";
import { ProductSearch } from "./pages/products/ProductSearch";
import { SettingsPage } from "./pages/settings/SettingsPage";
import { ResetPasswordPage } from "./pages/auth/ResetPasswordPage";
import SubscriptionPage from "./pages/Subscription/SubscriptionPage";
import "./App.css";

const SidebarElement: FC<PropsWithChildren> = ({ children }) => {
    return (
        <>
            <Sidebar />
            <div className="container">{children}</div>
        </>
    );
};

function App() {
    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                draggable
                pauseOnHover
                theme="colored"
            />
            <BrowserRouter>
                <Routes>
                    {/* <Route
                        path="/orders"
                        element={
                            <SidebarElement>
                                <OrderSearch />
                            </SidebarElement>
                        }
                    />
                    <Route
                        path="/products"
                        element={
                            <SidebarElement>
                                <ProductSearch />
                            </SidebarElement>
                        }
                    /> */}
                    <Route
                        path="/logs"
                        element={
                            <SidebarElement>
                                <LogsPage />
                            </SidebarElement>
                        }
                    />
                    <Route
                        path="/subscription"
                        element={
                            <SidebarElement>
                                <SubscriptionPage />
                            </SidebarElement>
                        }
                    />
                    <Route
                        path="/settings"
                        element={
                            <SidebarElement>
                                <SettingsPage />
                            </SidebarElement>
                        }
                    />
                    <Route path="/" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
